var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-responsive',{attrs:{"aspect-ratio":16/9}},[_c('div',{ref:"container",staticStyle:{"width":"100%","height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }